export default __webpack_public_path__ + "static/media/Circus_09.0152099b.png";